import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "form-group d-flex attachmentUploader" }
const _hoisted_2 = { class: "mt-2" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_file_input = _resolveComponent("file-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("label", null, _toDisplayString(_ctx.label), 1),
      _createElementVNode("div", null, [
        (_ctx.canUpload)
          ? (_openBlock(), _createBlock(_component_file_input, {
              key: 0,
              class: "form-control",
              modelValue: _ctx.fileToUpload,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fileToUpload) = $event))
            }, null, 8, ["modelValue"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(" Salva prima di caricare allegati ")
            ], 64))
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.uploadFile && _ctx.uploadFile(...args))),
          disabled: !_ctx.fileToUpload
        }, " Carica ", 8, _hoisted_3)
      ])
    ]),
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "preview", {}, () => [
        (_ctx.localValue && _ctx.localValue.publicUrl)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              style: {"max-height":"120px"},
              src: _ctx.localValue.publicUrl
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true)
      ], true)
    ])
  ]))
}